<script>
    import { createEventDispatcher } from "svelte";
    import SlideshowItem from "../../../common/SlideshowItem.svelte";
    import { _ } from "svelte-i18n";

    const dispatch = createEventDispatcher();

    export let audioGuide;
</script>

<SlideshowItem on:click={() => dispatch("click")} titleImage={audioGuide.image}>
    <div slot="content">
        <div class="headline-xs slogan">{audioGuide.title}</div>
        <div class="headline-s type">{$_("audio_guide")}</div>
        <div class="text-m">{$_("listen_now")}</div>
    </div>

    <div slot="more">
        <img src="./images/icons/headphones.svg" alt={$_("more")} />
    </div>
</SlideshowItem>
